import * as R from 'ramda'
import P from 'helpers/predicates'
import {
  RESET_FORM,
  UPDATE_USERNAME,
  UPDATE_EMAIL,
  UPDATE_NAME,
} from './constants'
import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'

const clearString = () => ''
const resetUsername = clearString
const resetEmail = clearString
const resetName = clearString

const updateString = (prev, current) => P.isNotNil(current)
  ? current
  : prev

const updateUsername = (prev, { username }) => updateString(prev, username)
const updateEmail = (prev, { email }) => updateString(prev, email)
const updateName = (prev, { name }) => updateString(prev, name)

const usernameReducer = createReducer('', {
  [RESET_FORM]: resetUsername,
  [UPDATE_USERNAME]: updateUsername,
  [UPDATE_EMAIL]: updateEmail
})

const emailReducer = createReducer('', {
  [RESET_FORM]: resetEmail,
  [UPDATE_EMAIL]: updateEmail
})

const nameReducer = createReducer('', {
  [RESET_FORM]: resetName,
  [UPDATE_NAME]: updateName
})

export default combineReducers({
  name: nameReducer,
  username: usernameReducer,
  email: emailReducer,
})
